/**
 * coverts a Uint8Array to a Blob
 */
export const uint8ArrayToBlob = (buffer: Uint8Array): Blob => {
  return new Blob([ buffer ]);
};
